import { render, staticRenderFns } from "./psychologicalLogin.vue?vue&type=template&id=e5264690&scoped=true"
import script from "./psychologicalLogin.vue?vue&type=script&lang=js"
export * from "./psychologicalLogin.vue?vue&type=script&lang=js"
import style0 from "./psychologicalLogin.vue?vue&type=style&index=0&id=e5264690&prod&lang=css"
import style1 from "./psychologicalLogin.vue?vue&type=style&index=1&id=e5264690&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5264690",
  null
  
)

export default component.exports